module.exports = "/assets/fe5a66ec1b4aaef7ff484f2b482494f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VX.png
// module id = 3061
// module chunks = 0